import styled from 'styled-components';

import { Typography } from '@useblu/ocean-react';

import { breakpointTo, bpMedium } from 'tokens';

import {
  colorInterfaceLightUp,
  colorInterfaceLightPure,
  colorInterfaceDarkUp,
  colorInterfaceDarkPure,
  colorInterfaceDarkDown,
  borderRadiusLg,
  spacingStackSm,
  fontWeightRegular,
  fontWeightBold,
  fontFamilyBase,
  fontSizeXs,
} from '@useblu/ocean-tokens/web/tokens';

export const Container = styled.div`
  max-width: 230px;
  height: fit-content;
  background-color: ${colorInterfaceLightUp};
  border-radius: ${borderRadiusLg};
  padding: 16px;

  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    background-color: transparent;
    display: none;
  }

  @media ${breakpointTo(bpMedium)} {
    width: 100%;
    max-width: 100%;
    background-color: ${colorInterfaceLightPure};
    padding: 8px 0px;
    overflow-y: hidden;
  }
`;

export const CustomRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacingStackSm};

  &:last-child {
    margin-bottom: 0px;
  }
`;

export const Description = styled(Typography).attrs(() => ({
  variant: 'description',
}))`
  &&& {
    margin: 0px;
    color: ${colorInterfaceDarkDown};
  }
`;

export const Value = styled.span`
  color: ${colorInterfaceDarkPure};
  font-size: 20px;
  line-height: 30px;
  font-weight: ${fontWeightBold};
  font-family: ${fontFamilyBase};
`;

export const Info = styled.span`
  color: ${colorInterfaceDarkPure};
  font-size: ${fontSizeXs};
  line-height: 24px;
  font-weight: ${fontWeightRegular};
  font-family: ${fontFamilyBase};
`;

export const PaymentTypeInfo = styled.span`
  color: ${colorInterfaceDarkUp};
  font-family: 'Nunito Sans';
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
`;
